module.exports = __webpack_public_path__ + "Roboto-Bold.ab96cca26751239828b8.woff2";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-Bold.woff2
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Bold.woff2
// module chunks = 13